module.exports = __webpack_public_path__ + "img/IMG_1024_L_Wood.942b8127.jpg";